import { Requester } from './Requester';
import { IContactRecord, IManifest } from '../types';

export const PostOrganizationContact = async ({
    clientId,
    contact,
    surveyId
}: {
    clientId: string;
    contact: IManifest;
    surveyId?: string;
}): Promise<IContactRecord | null> => {
    try {
        const response = await Requester<IContactRecord | null>({
            path: `organizations/${clientId}/contacts`,
            method: 'POST',
            payload: contact,
            searchParams: surveyId ? `surveyId=${surveyId}` : undefined
        });

        return response && Object.hasOwn(response, '_id') ? (response as IContactRecord) : null;
    } catch (e) {
        console.error('Create contact request failed');
        return Promise.reject(e);
    }
};
